import React, {
  ReactElement,
  useEffect,
  useState,
  useCallback,
} from 'react';
import { SchemaWithClient } from '../../types/SchemaWithClient';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button as MUIButton,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { SlidingPaneEdit } from '../Page/SlidingPaneEdit';
import AddIcon from '@mui/icons-material/Add';
import api from '../../services/api';
import { SlidingPaneAddNew } from '../Page/SlidingPaneAddNew';
import EditIcon from '@mui/icons-material/Edit';
import toast from 'react-hot-toast';
import Box from '@mui/material/Box';
import { corporate } from '../../schema/corporate';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { corporatePayment } from '../../schema/corporatePayment';
import Button from '@mui/material/Button';
import { CheckRounded, ClearRounded } from '@mui/icons-material';

export const Corporate = ({
  values,
  tableType,
}: {
  values: any;
  tableType: string;
}): ReactElement => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [properties, setProperties] = useState<any>([]);
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});
  const [addingEntity, setAddingEntity] = useState<any>({
    schema: undefined,
  });
  const [loading, setLoading] = useState<any>(false);

  const [schema, setSchema] = useState<SchemaWithClient<any>>(corporate);

  const [currentAddNewPaneEntity, setCurrentAddNewPaneEntity] = React.useState<
    any
  >({
    schema: schema,
    row: {},
    key: undefined,
  });

  const [paymentSchema, setPaymentSchema] = useState<SchemaWithClient<any>>(
    corporatePayment
  );

  const [
    currentAddNewPaymentPaneEntity,
    setCurrentAddNewPaymentPaneEntity,
  ] = React.useState<any>({
    schema: paymentSchema,
    row: {},
  });

  const fetchCorporates = useCallback(() => {
    setLoading(true);
    const searchParams = new URLSearchParams({});
    api
      .get(`/service-provider-corporates/${values.id}`, searchParams)
      .then((res: any) => {
        setProperties(res);
      });
  }, []);

  useEffect(() => {
    fetchCorporates();
  }, [values, schema]);

  return (
    <>
      <Stack direction={'column'}>
        <Box>
          <Button
            variant={'contained'}
            onClick={() => {
              setCurrentAddNewPaneEntity({
                row: {
                  id: 'new',
                  service_provider: {
                    id: values?.id,
                    name: values?.name,
                  },
                },
                schema: corporate,
              });
            }}
          >
            Add new Corporate data
          </Button>
        </Box>

        {properties.map((corporateItem: any) => {
          return (
            <>
              <Box
                component="section"
                sx={{
                  p: '20px',
                  background: '#f1f1f1',
                  borderRadius: '10px',
                  mt: '20px',
                  width: '100%',
                }}
              >
                <Stack
                  direction="row"
                  spacing={0}
                  sx={{
                    width: '100%',
                  }}
                  alignItems={'center'}
                >
                  <Stack
                    sx={{
                      width: '100%',
                    }}
                  >
                    {Object.keys(schema.columns).map(
                      (column, index: number) => {
                        const columnData: any =
                          schema.columns[column as keyof {}];

                        let value = corporateItem[`${column}`]
                          ? corporateItem[`${column}`]?.name
                            ? corporateItem[`${column}`].name
                            : corporateItem[`${column}`]
                          : '-';
                        if (column === 'permanent_contract') {
                          console.log(corporateItem[`${column}`]);
                          value = corporateItem[`${column}`] ? (
                            <CheckRounded fontSize={'small'} />
                          ) : (
                            <ClearRounded fontSize={'small'} />
                          );
                        }

                        return (
                          <>
                            <Stack
                              key={index}
                              direction="row"
                              spacing={0}
                              sx={{
                                width: '100%',
                                borderBottom: '1px solid #dfdbdb',
                              }}
                            >
                              <Box
                                sx={{
                                  flex: 1,
                                  display: 'flex',
                                  p: '5px',
                                  alignItems: 'center',
                                  background: '#f8f8f8',
                                  '& .MuiFormControl-root.MuiTextField-root': {
                                    background: '#fff',
                                  },
                                  borderRight: '1px solid #dfdbdb',
                                }}
                              >
                                <span
                                  className={'px-[8px]'}
                                >{`${columnData?.name}`}</span>
                              </Box>

                              <Box
                                sx={{
                                  flex: 2,
                                  p: '5px',
                                  '& .MuiFormControl-root.MuiTextField-root': {
                                    width: '100%',
                                    background: '#fff',
                                  },
                                  maxWidth: 'calc(100% - 204px)',
                                }}
                              >
                                {value}
                              </Box>
                            </Stack>
                          </>
                        );
                      }
                    )}
                  </Stack>

                  <Stack>
                    <IconButton
                      onClick={() => {
                        setOpenConfirmDialog({
                          row: corporateItem,
                          schema: corporate,
                        });
                      }}
                    >
                      <DeleteRoundedIcon color={'error'} />
                    </IconButton>

                    <IconButton
                      onClick={() => {
                        setOpenedSlidingPane({
                          schema: schema,
                          row: corporateItem,
                        });
                      }}
                    >
                      <EditIcon color={'primary'} />
                    </IconButton>
                  </Stack>
                </Stack>

                <Accordion
                  sx={{
                    marginTop: '10px',
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      '& .MuiAccordionSummary-content': {
                        alignItems: 'center',
                      },
                    }}
                  >
                    <Typography variant="h6" component="div">
                      Payments
                    </Typography>
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        setCurrentAddNewPaneEntity({
                          row: {
                            id: 'new',
                            corporate: {
                              id: corporateItem?.id,
                              name: corporateItem?.name,
                            },
                          },
                          schema: paymentSchema,
                        });
                      }}
                    >
                      <AddIcon />
                    </IconButton>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      {corporateItem.corporate_payments.map((payment: any) => {
                        return (
                          <Grid item xs={12}>
                            <Box
                              component="section"
                              sx={{
                                p: '20px',
                                background: '#f8f8f8',
                                borderRadius: '10px',
                                width: '100%',
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={0}
                                sx={{
                                  width: '100%',
                                }}
                                alignItems={'center'}
                              >
                                <Stack
                                  sx={{
                                    width: '100%',
                                  }}
                                >
                                  {Object.keys(paymentSchema.columns).map(
                                    (column, index: number) => {
                                      const paymentColumnData: any =
                                        paymentSchema.columns[
                                          column as keyof {}
                                        ];
                                      if (
                                        column === 'corporate' ||
                                        column === 'name'
                                      ) {
                                        return <></>;
                                      }

                                      let value = payment[`${column}`]
                                        ? payment[`${column}`]?.name
                                          ? payment[`${column}`].name
                                          : payment[`${column}`]
                                        : '-';

                                      return (
                                        <>
                                          <Stack
                                            key={index}
                                            direction="row"
                                            spacing={0}
                                            sx={{
                                              width: '100%',
                                              borderBottom: '1px solid #dfdbdb',
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                flex: 1,
                                                p: '5px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                '& .MuiFormControl-root.MuiTextField-root': {
                                                  background: '#fff',
                                                },
                                                borderRight:
                                                  '1px solid #dfdbdb',
                                              }}
                                            >
                                              <span
                                                className={'px-[8px]'}
                                              >{`${paymentColumnData.name}`}</span>
                                            </Box>

                                            <Box
                                              sx={{
                                                flex: 2,
                                                p: '5px',
                                                '& .MuiFormControl-root.MuiTextField-root': {
                                                  width: '100%',
                                                  background: '#fff',
                                                },
                                                maxWidth: 'calc(100% - 204px)',
                                              }}
                                            >
                                              {value}
                                            </Box>
                                          </Stack>
                                        </>
                                      );
                                    }
                                  )}
                                </Stack>

                                <Stack>
                                  <IconButton
                                    onClick={() => {
                                      setOpenConfirmDialog({
                                        row: payment,
                                        schema: corporatePayment,
                                      });
                                    }}
                                  >
                                    <DeleteRoundedIcon color={'error'} />
                                  </IconButton>

                                  <IconButton
                                    onClick={() => {
                                      setOpenedSlidingPane({
                                        schema: paymentSchema,
                                        row: payment,
                                      });
                                    }}
                                  >
                                    <EditIcon color={'primary'} />
                                  </IconButton>
                                </Stack>
                              </Stack>
                            </Box>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Box>
            </>
          );
        })}
      </Stack>

      {currentAddNewPaneEntity?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={currentAddNewPaneEntity?.schema}
            mainSchema={schema}
            id={currentAddNewPaneEntity?.row?.id}
            hasSlidingPane={false}
            onSubmit={(result: any) => {
              setCurrentAddNewPaneEntity({
                schema: schema,
                row: {},
                key: undefined,
              });
              fetchCorporates();
            }}
            propertiesFromTable={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            row={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            onClose={(value) => {
              setCurrentAddNewPaneEntity({
                schema: schema,
                row: {},
                key: undefined,
              });
            }}
          />
        </>
      )}

      {openConfirmDialog && (
        <Dialog
          open={openConfirmDialog}
          onClose={() => {
            setOpenConfirmDialog(false);
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {'Are you sure you want to delete it?'}
          </DialogTitle>
          <DialogActions>
            <MUIButton
              onClick={() => {
                setOpenConfirmDialog(false);
              }}
            >
              Cancel
            </MUIButton>
            <MUIButton
              variant={'contained'}
              color={'error'}
              onClick={() => {
                const deletedRow = openConfirmDialog?.row;
                openConfirmDialog?.schema.client
                  .delete(deletedRow.id as number, { id: deletedRow.id })
                  .then((res: any) => {
                    fetchCorporates();

                    toast.success(
                      `Successfully deleted ${
                        openConfirmDialog?.schema.name
                      }: ${
                        deletedRow?.name ? deletedRow?.name : deletedRow?.id
                      }`
                    );
                    setOpenConfirmDialog(false);
                  })
                  .catch((error: any) => {
                    let array: any = [];
                    for (let errorKey in error) {
                      for (let errorMsg in error[errorKey]) {
                        array.push(`${error[errorKey][errorMsg]}`);
                      }
                    }
                    toast.error(array.join(','));
                  });
              }}
              autoFocus
            >
              Delete
            </MUIButton>
          </DialogActions>
        </Dialog>
      )}

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={() => {
            fetchCorporates();
            setOpenedSlidingPane({});
          }}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(value) => {
            setOpenedSlidingPane({});
          }}
        />
      )}
    </>
  );
};
